import ecomInterceptor from "../interceptors/ecomInterceptor";

// Define request/response types for okay clicks
export interface ResolveDataRequest {
  dataType: string;
}

export interface ResolveDataResponse {
  success: boolean;
  message: string;
  data?: any;
}

const dataRemovalNotifyService = {
  resolveDataRemoved: async (
    data: ResolveDataRequest
  ): Promise<ResolveDataResponse> => {
    try {
      const response = await ecomInterceptor.put<ResolveDataResponse>(
        "/users/toggle-alert-status",
        data
      );
      return response.data;
    } catch (error: any) {
      const message =
        error?.response?.data?.detail ||
        error.message ||
        "Failed to log okay click";
      throw new Error(`logOkayClick error: ${message}`);
    }
  },

  getUserNotificationStatus: async (
    userId: string
  ): Promise<ResolveDataResponse> => {
    try {
      const response = await ecomInterceptor.get<ResolveDataResponse>(
        "/users/get-alert-status"
      );
      return response.data;
    } catch (error: any) {
      const message =
        error?.response?.data?.detail ||
        error.message ||
        "Failed to fetch okay click history";
      throw new Error(`getOkayClicks error: ${message}`);
    }
  },
};

export default dataRemovalNotifyService;
